export class VkGoal {

    send(name, params) {
        try {
            if (typeof VK !== 'undefined') {
                if (params) {
                    VK.Goal(name, params);
                    console.log("VK.Goal('" + name + "'," + params + ")");
                } else {
                    VK.Goal(name);
                    console.log("VK.Goal('" + name + "')");
                }
            }
        } catch (e) {
            console.log('VkGoal error: ' + e);
        }
    }
    onPageLoad(params) {
        if (params.page && params.page === 'completion') {
            this.send('purchase');
        }
    }
    onLoadDetail(product) {
        if (product) {
            this.send('view_content');
        }
    }
    onAddToCart() {
        this.send('add_to_cart');
    }
    onOneClickPurchased() {
        this.send('purchase');
    }
}
